import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { notificationsActions } from '../../../data/actions/notifications';

class MissingFacebookDataIssue extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}
	
	componentDidMount(){
		this.props.dispatch(notificationsActions.getAdminNotifications())
	}


	render (){
		const { adminLoading, adminNotifications } = this.props.notifications;
		if(!adminLoading && Array.isArray(adminNotifications) && adminNotifications.length > 0) {
			return <React.Fragment>
				{adminNotifications.map(notification=><div key={notification.id} className="missing-data-warning-holder">
					<div className="missing-data-warning">
						{notification.message}
					</div>
				</div>)}
			</React.Fragment>	
		}
		return null;
	}
}

function mapStateToProps(state) {
	return {
		notifications: state.notifications
	} 
}

export default connect(mapStateToProps)(MissingFacebookDataIssue)